'use strict';

angular.module('userRequestEditControllers')

.controller('ByBusinessTaskController', ['$scope', '$state', '$q', 'editAccessRequestService', 'businessSystemService', 'businessTask', 'businessTasks', 'sameAsEmployee', 'sameAsSysRoles', 'existingSysRoles', 'allowableSysRoles', 'defaultEntitlementSysRoles', 'businessTaskSystemRoles', 'arrayHelpers', function ($scope, $state, $q, editAccessRequestService, businessSystemService, businessTask, businessTasks, sameAsEmployee, sameAsSysRoles, existingSysRoles, allowableSysRoles, defaultEntitlementSysRoles, businessTaskSystemRoles, arrayHelpers) {

    // Scopping
    $scope.businessTasks = businessTasks;
    $scope.businessTask = businessTask;

    // Get pendings an existings
    var getPendingsAndExistings = function () {

        $scope.taskSystemRoles = _.filter(businessTaskSystemRoles, function (taskSysRole) {
            return taskSysRole.BusinessTaskID === businessTask.BusinessTaskID;
        });

        if ($scope.ctxSearchBusinessTask.withSearch()) {
            $scope.taskSystemRoles = _.filter($scope.taskSystemRoles, function (taskSysRole) {
                return _.findIndex($scope.ctxSearchBusinessTask.businessTasks, { BusinessTaskID: taskSysRole.BusinessTaskID }) !== -1;
            });
        }

        if (!_.isUndefined(sameAsEmployee)) {
            $scope.sameAsEmployee = sameAsEmployee.data;
        }

        // Get all same as roles
        var sameAsList = _.filter(sameAsSysRoles, function (sameAs) {
            return _.findIndex($scope.taskSystemRoles, { SystemRoleID: sameAs.SystemRoleID }) !== -1;
        });
        $scope.userRequest.sameAsSysRoles = sameAsList;
        $scope.groupsOfSameAs = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem($scope.userRequest.sameAsSysRoles), 4);

        // Get all pendings roles
        var pendings = _.filter($scope.userRequest.SystemRolePendings, function (pending) {
            return _.findIndex($scope.taskSystemRoles, { SystemRoleID: pending.SystemRoleID }) !== -1;
        });
        $scope.userRequest.pendings = pendings;

        // Merge pendings and existings roles
        var existings = _.filter(existingSysRoles, function (existing) {
            return _.findIndex($scope.taskSystemRoles, { SystemRoleID: existing.SystemRoleID }) !== -1;
        });
        existings = editAccessRequestService.mergePendingsAndExistingsRoles(pendings, existings);
        $scope.userRequest.existings = existings;

        // Get existings
        $scope.groupsOfExistings = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem(existings), 4);

        // Get default entitlements
        var defEntitlements = _.chain(defaultEntitlementSysRoles)
                               .filter(function (defEntitlement) {
                                   return _.findIndex($scope.taskSystemRoles, { SystemRoleID: defEntitlement.SystemRoleID }) !== -1;
                               })
                               .filter(function (defEntitlement) {
                                   return _.findIndex(sameAsList, { SystemRoleID: defEntitlement.SystemRoleID }) === -1;
                               })
                               .value();
        $scope.userRequest.defEntitlements = defEntitlements;

        // Get other allowables
        var allAllowables = _.chain(allowableSysRoles)
                             .filter(function (allowable) {
                                 return _.findIndex($scope.taskSystemRoles, { SystemRoleID: allowable.SystemRoleID }) !== -1;
                             })
                             .filter(function (allowable) {
                                    return _.findIndex(sameAsList, { SystemRoleID: allowable.SystemRoleID }) === -1;
                             })
                             .value();

        // Union allowables and default entitlements
        var allowablesAndEntitlements = _.union(allAllowables, defEntitlements);
        allowablesAndEntitlements = _.uniq(allowablesAndEntitlements, function (e) { return e.SystemRoleID; });

        // Add pending for allowables and default entitlements
        var otherAllowables = _.map(allowablesAndEntitlements, function (allowable) {
            var pending = _.find(pendings, { SystemRoleID: allowable.SystemRoleID })
            if (!_.isUndefined(pending)) {
                allowable.ToAdd = pending.ToAdd;
                allowable.ToRemove = pending.ToRemove;
                allowable.ToKeep = pending.ToKeep;
            }
            return allowable;
        });
        $scope.userRequest.otherAllowables = otherAllowables;

        $scope.userRequest.allowablesNotPendings = _.filter($scope.userRequest.otherAllowables, function (allowable) {
            return _.isUndefined(allowable.ToAdd);
        });

        $scope.groupsOfAllowables = arrayHelpers.getGroupsOfArrays(
            businessSystemService.systemRole.bySystem(otherAllowables), 4);
    }

    $scope.$watch('ctxSearchBusinessTask.businessTasks', function (newValue, oldValue) {
        getPendingsAndExistings();
    }, true);

    // Same As
    $scope.addAllSameAs = function () {

        $q.all(_.map($scope.userRequest.sameAsSysRoles, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (addedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }

    // Allowables
    $scope.addAllAllowables = function () {

        $q.all(_.map($scope.userRequest.allowablesNotPendings, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preAdd($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (addedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }

    // Remove all current permissions
    $scope.removeAllExistings = function () {
        var existingsToRemove = _.filter($scope.userRequest.existings, function (existing) {
            return _.isUndefined(existing.ToAdd);
        });

        $q.all(_.map(existingsToRemove, function (systemRole) {
            return editAccessRequestService.systemRolePendings.preClose($scope.userRequest.UserAccessRequestID, systemRole.SystemRoleID);
        }))
        .then(function (removedSystemRoles) {
            $state.go($state.current, {}, { reload: true });
        });
    }
}]);